<script>
import { BTable } from "bootstrap-vue";

export default {
  extends: BTable
};
</script>